import script from "./exchangeStore.vue?vue&type=script&setup=true&lang=js"
export * from "./exchangeStore.vue?vue&type=script&setup=true&lang=js"

import "./exchangeStore.vue?vue&type=style&index=0&id=1dc7b2ae&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc7b2ae"]])

export default __exports__